import { useMemo, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import toastOptions from "../assets/constants/toast";

const useScopeManagement = (availableScopes, token, fetchScopes) => {
    const categoryOptions = useMemo(() => {
        if (!availableScopes || typeof availableScopes !== "object" || Object.keys(availableScopes).length === 0) {
            return [];
        }
        const categories = Object.keys(availableScopes).map((category) => ({
            value: category,
            label: category.charAt(0).toUpperCase() + category.slice(1),
        }));
        return categories;
    }, [availableScopes]);

    const createScope = useCallback(
        async (scopeData) => {
            try {
                await axios.post(
                    process.env.REACT_APP_UPA_API_HOST + "tokens/scopes",
                    {
                        name: scopeData.name.trim(),
                        description: scopeData.description.trim(),
                        category: scopeData.category.trim(),
                    },
                    { headers: { Authorization: "Bearer " + token } }
                );

                toast.success("Scope créé avec succès", toastOptions);
                if (fetchScopes) fetchScopes();
            } catch (error) {
                toast.error(error.response?.data?.error || "Erreur lors de la création du scope", toastOptions);
                throw error;
            }
        },
        [token, fetchScopes]
    );

    const generateScopeName = useCallback((category, action) => {
        if (category && action) {
            return `${category}:${action}`;
        }
        return action || "";
    }, []);

    return {
        categoryOptions,
        createScope,
        generateScopeName,
    };
};

export default useScopeManagement;
